export enum ExerciseTimeSinceStartEnum {
  LESS_THAN_MONTH = 'LESS_THAN_MONTH',
  LESS_THAN_THREE_MONTHS = 'LESS_THAN_THREE_MONTHS',
  LESS_THAN_ONE_YEAR = 'LESS_THAN_ONE_YEAR',
  MORE_THAN_ONE_YEAR = 'MORE_THAN_ONE_YEAR',
}
